/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { capitalizeWords } from '../../../utilities/capitalizeWords';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from '@mui/material';
import { CustomTableCell } from '../../index';
import { formatISOToPHT } from '../../../utilities/date';

export const EducationalBackground = (props) => {
  return (
    <Box sx={{ mb: 3, padding: '12px' }}>
      <TableContainer
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
          padding: '12px',
        }}
      >
        <Table sx={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <CustomTableCell value="Level" />
              <CustomTableCell value="Name of School" />
              <CustomTableCell value="Degree" />
              <CustomTableCell value="Year Graduated" />
              <CustomTableCell value="Highest Attained" />
              <CustomTableCell value="Start From" />
              <CustomTableCell value="Ended On" />
              <CustomTableCell value="Honors/Awards Received" />
            </TableRow>
          </TableHead>
          {props.empEducation?.map((education) => (
            <TableRow key={education._id}>
              <TableCell>{capitalizeWords(education.level)}</TableCell>
              <TableCell>{capitalizeWords(education.school)}</TableCell>
              <TableCell>{capitalizeWords(education.degree)}</TableCell>
              <TableCell>{formatISOToPHT(education.gradyear)}</TableCell>
              <TableCell>
                {capitalizeWords(education.highestattained)}
              </TableCell>
              <TableCell>{formatISOToPHT(education.startdate)}</TableCell>
              <TableCell>{formatISOToPHT(education.enddate)}</TableCell>
              <TableCell>{capitalizeWords(education.honors)}</TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Box>
  );
};
